


























import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class DragDropImage extends Vue {
  @Prop() private imgUrl!: string
  @Prop({ default: 'เลือกรูปภาพ' }) private title!: string
  @Prop({ default: 'inputImgs' }) private idImage!: string
  @Prop({ default: 200 }) private maxSize!: number
  @Prop({ default: 0 }) private thumbnailSize!: number
  @Prop({ default: 500 }) private width!: number
  @Prop({ default: 500 }) private height!: number
  @Prop({ default: 'image/jpeg' }) private imgType!: string
  @Prop({ default: false }) private isZoom!: boolean
  @Prop({ default: 'mdi-folder-multiple-image' }) private icon!: string

  private file = ''
  private thumbnail = ''
  private zoomImageDialog = false

  private getImgUrl() {
    return this.imgUrl
  }

  private getFiles(id) {
    document.getElementById(id).click()
  }

  private imageToDataUri(img, maxSize, type, callback) {
    const image = new Image()
    image.onload = () => {
      const canvas = document.createElement('canvas')
      let x = 0
      let y = 0
      let width = image.width
      let height = image.height
      if (width > height) {
        height = height * maxSize / width
        width = maxSize
        y = (maxSize - height) / 2
      } else {
        width = width * maxSize / height
        height = maxSize
        x = (maxSize - width) / 2
      }
      canvas.width = maxSize
      canvas.height = maxSize
      const ctx = canvas.getContext('2d')
      if (type !== 'image/png') {
        ctx.fillStyle = 'white'
        ctx.fillRect(0, 0, maxSize, maxSize)
      }
      // console.log(x, y, width, height)
      ctx.drawImage(image, x, y, width, height)
      callback(canvas)
    }
    image.src = img
  }

  private onChange(e) {
    const file = e.target.files[0]
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      const fileInfo = {
        name: file.name,
        type: file.type,
        size: Math.round(file.size / 1000) + ' kB',
        base64: reader.result,
        file,
      }
      this.imageToDataUri(fileInfo.base64, this.maxSize, this.imgType, (canvasFile) => {
        this.file = canvasFile.toDataURL(this.imgType, 0.8)
        const result = {
          file: this.file,
          thumbnail: '',
        }
        if (this.thumbnailSize > 0) {
          this.imageToDataUri(fileInfo.base64, this.thumbnailSize, this.imgType, (canvasThumbnail) => {
            this.thumbnail = canvasThumbnail.toDataURL(this.imgType, 0.4)
            result.thumbnail = this.thumbnail
            this.$emit('input', result)
          })
        } else {
          this.$emit('input', result)
        }
      })
    } // reader.onload
  }

  private openDialog(modelDialog: 'zoomImageDialog') {
    this[modelDialog] = true
  }
}
